
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AkkhorLayout from "../layout/akkhor";
import { URL_LIST_ALL } from "../configs/api";
import { useSelector } from "react-redux";
import Axios from "axios";
import men_teacher from "../assets/img/men-teacher.png"
import { Modal, Pagination } from "react-bootstrap";
import Moment from "react-moment";
import Spinner from "../component/Spinner";

export default function DanhSachProfile() {
    const { user } = useSelector((state) => state.auth);
    const [params, setParam] = useState('');
    const [fullname, setFullname] = useState();
    const [filterShow, setFilterShow] = useState(false)
    const [listProfile, setListProfile] = useState([])
    const [show, setShow] = useState(false)
    const [modalInfo, setModalInfo] = useState(null)
    const [loading, setLoading] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        let _param = ''
        if (fullname !== '') _param += "&fullname=" + fullname
        setParam(_param);
    };

    useEffect(
        function () {
            let mounted = true;
            setLoading(true)
            Axios.get(URL_LIST_ALL + "learninghub_profiles?limit=50&orderby=position-asc"+params, user.config)
                .then(async (res) => {
                    if (res.data.status === "success") {
                        if (mounted) {
                            setListProfile(res.data.data);
                        }
                    } else console.log(res.data.message);
                    setLoading(false)
                })
                .catch((err) => console.log(err));
            return () => (mounted = false);
        }, [user]
    );

    const linkify = (html) =>
        html ? html.replace(
            /(?<!src="|href="|">)(https?:\/\/[^\s<]+)/g,
            '<a href="$1" class="text-danger" target="_blank" rel="noopener noreferrer">$1</a>'
        ) : html;


    return (<AkkhorLayout idrole="dashboard">
        <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    Profile giảng viên
                </li>
            </ul>
        </div>
    
        <div className="w-100 list-profile">
            <div className="row">
                <h3 className="col-12 text-center mb-3">BHS Coach Hub</h3>
                 {loading ? <div className="w-100 text-center"><Spinner /></div> : ''}
                {listProfile && listProfile.map((profile) => {
                    return (<div className="col-12 col-sm-3 col-lg-2 profile-item mb-3" key={profile.id}>
                        <div className="wrapper border shadow" onClick={() => {
                            setModalInfo(profile)
                            setShow(true)
                        }}>
                            <div className="w-100 d-flex justify-content-center p-3">
                                <div className="avatar-group">
                                    <img src={profile.avatar ? profile.avatar : men_teacher} alt="" className="" />
                                </div>
                            </div>
                            <div className="w-100 p-3 pt-0">
                                <h5 className="w-100 text-center">{profile.fullname}</h5>
                                <p className="w-100 text-center mt-2">{profile.chucvu}</p>
                                <p className="w-100 text-center"><strong>{profile.part_title}</strong></p>
                                <p className="w-100 text-center"><strong>{profile.company}</strong></p>
                            </div>
                        </div>
                    </div>)
                })}
            </div>
        </div>
        <Modal show={show} onHide={() => {
            setShow(false)
            setModalInfo(null)
        }} animation={true} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Thông tin giảng viên</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="w-100 modal-profile">
                    {modalInfo &&
                        <div className="row">
                            <div className="col-12 col-sm-4">
                                <img src={modalInfo.avatar ? modalInfo.avatar : men_teacher} alt="" className="avatar" />
                            </div>
                            <div className="col-12 col-sm-8">
                                <h4 className="mb-3 mt-2">Họ và tên: {modalInfo.fullname}</h4>
                                <p>Chức danh: {modalInfo.chucvu}</p>
                                <p>Phòng ban: {modalInfo.part_title}</p>
                                <p>Công ty: {modalInfo.company}</p>
                                <p>Liên hệ: {modalInfo.email}</p>
                                <p>Sinh nhật: <Moment format="DD/MM/YYYY">{modalInfo.birthday}</Moment></p>
                                {/* <p>{modalInfo.marital_status && modalInfo.marital_status != "Độc thân" ? modalInfo.marital_status : "Hiện vẫn đang độc thân"}</p> */}
                            </div>
                            <div className="col-12 mt-2">
                                <div className="w-100 mt-2 post-content" dangerouslySetInnerHTML={{ __html: linkify(modalInfo.description) }} />
                            </div>
                        </div>
                    }
                </div>
            </Modal.Body>
        </Modal>
    </AkkhorLayout>);
}
